import { useParams } from 'react-router-dom'

import EditTemplateWeek from 'modules/shift_management/components/Settings/ShiftTemplates/Content/EditTemplateWeek'

const EditTemplateWeekPage = () => {
  const { id, shiftTemplateId, weekId } = useParams()

  return (
    <EditTemplateWeek
      subscriptionAddonId={id as string}
      shiftTemplateId={Number(shiftTemplateId)}
      weekId={Number(weekId)}
    />
  )
}

export default EditTemplateWeekPage
